import * as _ from 'lodash';
import {Utils} from "./Utils";

export class JSonSerializer {

  LOG = false;
  USE_TYPE_SCRIPT_CLASS_NAME = true; //TODO: Must be turned on for Angular 14

  readProp<T, K extends keyof T>(obj: T, key: K) {
    return obj[key];
  }

  writeProp<T, K extends keyof T>(obj: T, key: K, val: any) {
    obj[key] = val;
  }



  /*
  toKeysBySample<T>(value: T): (keyof T)[] {
    return Object.keys(value);
  }
  */
  // const fooPropNames = toKeysBySample(mySample);

  // identity<T>(arg: T): T {
  //   typeof arg;
  //  //return arg;
  // }

  deserializeArray( source: any[], factoryMethod: Function,removePropertiesNotFoundInSource=true): any[] {
    const res = new Array();
    for (const bean of source ){
      const instance = factoryMethod.apply(bean);
      this.deserialize(bean, instance,removePropertiesNotFoundInSource);
      res.push(instance);
    }
    return res;
  }

  private log(data: string){
    if ( this.LOG ) {
      console.log(data);
    }
  }

  deserialize(source: any, target: any,removePropertiesNotFoundInSource=true) {

    if (Utils.isNullOrUndefined(source)){
      this.log('source is null or undefined');
      return;
    }

     // type Keys = keyof typeof target;
    // Reflect.getPrototypeOf(target);
    // Object.create()
    const createSpecialElement = this.readProp(target, '_createSpecialElement');


    for (const propName of Object.getOwnPropertyNames(source)) {
        this.log('Source PropertyName: ' + propName);

      if (! Utils.isNullOrUndefined(createSpecialElement) ) {
        if (typeof createSpecialElement === 'function') {
          this.log('Calling _createSpecialElement ' + propName);
          const res = target._createSpecialElement(propName, this.readProp(source, propName));
          if (res) {
            this.log('Deserialize has been done for ' + propName + ' with the _createSpecialElement')
            continue;
          }
        } else {
          throw new Error('[JSonSerializer] Method _createSpecialElement found but not a function.');
        }
      }


      const propertyType = typeof this.readProp(source, propName );
        if ('object' === propertyType) {
          this.log(' Object ');
          const targetProperty = this.readProp(target, propName);
          if (Utils.isNullOrUndefined(targetProperty)) {
            console.log('[JSonSerializer] Property ' + propName + ' should be initialized in ' + target.constructor.name + ', or a _createSpecialElement should be created.');
            continue;
          }
          // console.log(' targetProperty: ' + targetProperty);
          this.log(' targetProperty.ctor.name: ' + targetProperty.constructor.name);
          if ( 'Array' === targetProperty.constructor.name ) {

            const method = this.readProp(target, '_createFromArray');
            if ( Utils.isNullOrUndefined(method) ) {
              throw new Error('[JSonSerializer] Method _createFromArray(propertyName: string, data: any) NOT found on ' + target.constructor.name + '.');
            } else if ( typeof method === 'function') {
              this.log('Calling _createFromArray ' + propName);
               target._createFromArray(propName, this.readProp(source, propName ));
            } else {
              throw new Error('[JSonSerializer] Method _createFromArray found but not a function.');
            }

            // throw new Error('[JSonSerializer] Property ' + propName + ' should be initialized in ' + target.constructor.name + '.');
            // fkjdsf
            // console.log(' identity targetProperty.ctor.name: ' + this.identity(targetProperty));
            // console.log(' identity targetProperty.ctor.name: ' + ( typeof targetProperty ) );
          }else {

            this.deserialize(this.readProp(source, propName), targetProperty,removePropertiesNotFoundInSource);
          }

        }else {
          this.log(' Standard Type: ' + propertyType);
          // console.log(' Name of the constructor... ' +  )
          // console.log('Read Target: ' + this.readProp(target, propName));
//          this.writeProp(target, propName,  this.readProp(source, propName));
          this.writeProp(target, propName,  this.readProp(source, propName));
          this.log('Wrote Target: ' + this.readProp(target, propName));
        }
    }
    if (removePropertiesNotFoundInSource === true){
      // Putting to undefined if exists in target but can't be found in source
      this.removePopertiesNotFoundInSource(source, target);
    }
    this.runPostDeserialization(source,target);
  }

  private getClassName(obj: any): string {
    this.log('TypeScript: ' + obj.constructor.name);
    if (this.USE_TYPE_SCRIPT_CLASS_NAME){
      return obj.constructor.name;
    }
    const funcNameRegex = /function (.{1,})\(/;
    const results = (funcNameRegex).exec(obj.constructor.toString());
    return (results && results.length > 1) ? results[1] : '';
  }

  public hasAncestor( ancestor: string, obj: any): boolean {
    if (!obj) {
      return false;
    }
    let className = this.getClassName(obj);
    this.log('Source className: ' + className + ' ancestor ' + ancestor);
    while ((className = this.getClassName(obj)) !== 'Object') {
      this.log('Source className: ' + className);
      if (className === ancestor) {
        return true;
      }
      obj = Object.getPrototypeOf(obj);
    }

    return false;
  }

  /**
   * Replace all CustomCode by their code.
   * THIS IS NOT Recursive aka wont check for children...
   */
  public prepareForJsonNonRecursive( source: any): any {
    if (!source) {
      return null;
    }
    const res = _.cloneDeep(source);

    for (const propName of Object.getOwnPropertyNames(res)) {
      this.log('Source PropertyName: ' + propName);
      const property = this.readProp(res, propName);
      if (this.hasAncestor('CustomCode', property)) {
          this.writeProp(res, propName, property.code);
      }
    }
    return res;
  }

  public prepareForJson( source: any): any {
    if (!source) {
      return null;
    }
    const res = _.cloneDeep(source);

    for (const propName of Object.getOwnPropertyNames(res)) {
      const propertyType = typeof this.readProp(source, propName );
      this.log('Source PropertyType: ' + propName + ' ' + propertyType);
      // if ('object' === propertyType) {
      const property = this.readProp(source, propName);
      if (this.hasAncestor('CustomCode', property)) {
        this.writeProp(res, propName, property.code);
      }else if ('object' === propertyType) {
        this.writeProp(res,propName,this.prepareForJson(property));
      }
    }
    return res;
  }


  public serialize( source: any): string {

    if (!source) {
      return null;
    }
    let res = '';
//    console.log('Constructor Name: ' + source.constructor.name);
    if ( 'Array' === source.constructor.name ) {
  //    console.log('Working on an Array');
      res += '';
      for (const b of source ){
        if ('object' === typeof b) {
          res += this.serialize(b);
        } else {
          if (res.length > 0) {
            res += ', ';
          }
          res += JSON.stringify(b);
        }
        // res += '\"' + propName + '\": ' + this.serialize(property);
      }
      res = '[' + res + ']';
    }else if ('Date' === source.constructor.name ) {
      res += JSON.stringify(source);
    }else if (this.hasAncestor('CustomCode', source)) {
      res += '\"' + source.code + '\"';
    }else {
      for (const propName of Object.getOwnPropertyNames(source)) {
    //    this.log('Source PropertyName: ' + propName);
        const property = this.readProp(source, propName);
        const propertyType = typeof property;
        if ('object' === propertyType) {
          const tmp = this.serialize(property);
          if (tmp) {
            if (res.length > 0) {
              res += ', ';
            }
            res += '\"' + propName + '\": ' + tmp;
          }
        }else {
          if (res.length > 0) {
            res += ', ';
          }
          res += '\"' + propName + '\": ' + JSON.stringify(property);
        }
      }
      res = '{' + res + '}';
    }


    return res;
  }

  private removePopertiesNotFoundInSource( source: any, target: any) {

    for (const propName of Object.getOwnPropertyNames(target)) {
      this.log('Target PropertyName: ' + propName);

      if (Utils.isNullOrUndefined(this.readProp(source, propName))) {
        this.log('Property ' + propName + ' not found in source, removing it from target');
        delete target[propName];
      }
    }
  }

  private runPostDeserialization( source: any, target: any) {
    const postDeserialize = this.readProp(target, '_postDeserialize');
    if (!Utils.isNullOrUndefined(postDeserialize)) {
      if (typeof postDeserialize === 'function') {
        const res = target._postDeserialize();
        this.log('Ran _postDeserialize()');
      }
    }
  }

}




//
// console.log('PropertyName2: ' + Keys.);
//  for (const propName of Keys) {
//    console.log('PropertyName2: ' + propName);
//  }

// const fooPropNames = Object.keys(target);
//
// for (const propName in fooPropNames) {
//   console.log('propName: ' + propName);
// }

/*
 console.log('Deserializing ' + target + ' ' + typeof target + ' ' + typeof source);
 for (const propName of Object.getOwnPropertyNames(target)) {
 console.log('PropertyName1: ' + propName);
 }
 for (const propName of target) {
 console.log('PropertyName2: ' + propName);
 }

 let obj: EmployeeInfo = new EmployeeInfo();
 console.log('Deserializing2 ' + obj + ' ' + typeof obj);

 for (const propName of Object.getOwnPropertyNames(obj)) {
 console.log('PropertyName3: ' + propName);
 }
 */
/*
 let lang: ILanguage;
 // let lang: LanguageFr;
 lang = new LanguageEn();
 // console.log('Working on ' + JSON.stringify(lang) + ' ' + lang.HELLO);
 let array = Object.getOwnPropertyNames(lang);
 for (let i = 0; i < array.length; i++ ) {
 console.log('Working on ' + array[i]);
 }

 for (const propName of Object.getOwnPropertyNames(lang)) {
 console.log('PropertyName3: ' + propName);
 }
 */

/*
 const target = Object.getOwnPropertyNames(this);

 const array = Object.getOwnPropertyNames(json);

 for (let i = 0; i < array.length; i++ ) {
 this.get
 // console.log('Working on ' + array[i] + ' ' + langCountry);
 // translate.set(array[i], lang[array[i]], langCountry );

 }
 */

